<main class="atw-container">
  <section class="apply-section" id="cvUploader">
    <div class="section-title">
      <span>{{ 'atw.apply.sectionNumber' | transloco }}</span>

      <div>
        <h2>{{ 'atw.apply.title' | transloco }}</h2>
        <p>{{ 'atw.apply.subtitle' | transloco }}</p>
      </div>
    </div>

    <form class="apply-card" novalidate (submit)="submitCv($event)">
      <div class="form-grid">
        <label>
          <span>{{ 'atw.apply.fullName' | transloco }}</span>
          <input
            type="text"
            required
            [placeholder]="'atw.apply.fullNamePlaceholder' | transloco"
            [value]="form.name"
            [disabled]="isUploading"
            (input)="form.name = $any($event.target).value"
          />
        </label>

        <label>
          <span>{{ 'atw.apply.phoneNumber' | transloco }}</span>
          <input
            type="text"
            required
            inputmode="tel"
            [placeholder]="'atw.apply.phonePlaceholder' | transloco"
            [value]="form.phone"
            [disabled]="isUploading"
            (input)="form.phone = $any($event.target).value"
          />
        </label>

        <label class="full">
          <span>{{ 'atw.apply.emailAddress' | transloco }}</span>
          <input
            type="email"
            [placeholder]="'atw.apply.emailPlaceholder' | transloco"
            [value]="form.email"
            [disabled]="isUploading"
            (input)="form.email = $any($event.target).value"
          />
        </label>
      </div>

      <div
        class="pdf-uploader"
        [class.drag-over]="dragOver"
        [class.has-file]="selectedFile"
        (click)="!isUploading && fileInput.click()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <input
          #fileInput
          type="file"
          accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.doc,.docx"
          hidden
          [disabled]="isUploading"
          (change)="onFileChange($event)"
        />

        <ng-container *ngIf="!selectedFile">
          <div class="upload-icon">
            <img
              class="img-l"
              src="assets/as/30.webp"
              [alt]="'atw.apply.uploadIconAlt' | transloco"
            />
          </div>

          <h3>{{ 'atw.apply.dropTitle' | transloco }}</h3>
          <p>{{ 'atw.apply.dropText' | transloco }}</p>

          <button type="button" class="browse-btn">
            {{ 'atw.apply.chooseCv' | transloco }}
            <span>↑</span>
          </button>
        </ng-container>

        <ng-container *ngIf="selectedFile">
          <div class="file-preview">
            <div class="file-icon">{{ getFileTypeLabel(selectedFile) }}</div>

            <div class="file-info">
              <strong>{{ selectedFile.name }}</strong>
              <span>{{ formatFileSize(selectedFile.size) }}</span>
            </div>

            <button
              type="button"
              class="remove-file"
              [disabled]="isUploading"
              [attr.aria-label]="'atw.apply.removeFile' | transloco"
              (click)="removeFile($event)"
            >
              ×
            </button>
          </div>
        </ng-container>
      </div>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="success-message" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      <div class="upload-progress" *ngIf="isUploading">
        <div class="progress-top">
          <span>{{ 'atw.apply.submitting' | transloco }}</span>
          <strong>{{ progress }}%</strong>
        </div>

        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="progress"></div>
        </div>
      </div>

      <button
        class="submit-btn"
        type="submit"
        [disabled]="!selectedFile || isUploading"
      >
        <span *ngIf="!isUploading">
          {{ 'atw.apply.submitButton' | transloco }}
        </span>

        <span *ngIf="isUploading">
          {{ 'atw.apply.processing' | transloco }}
        </span>
      </button>
    </form>
  </section>
</main>